import { ArrowDownIcon, ArrowUpIcon, ChevronDownIcon, ChevronUpIcon, ShoppingCartIcon, StarIcon } from "@heroicons/react/24/solid";
import { Accordion, AccordionBody, AccordionHeader, Button, Card, CardBody, CardHeader, Carousel, Collapse, List, ListItem, ListItemPrefix, Option, Radio, Typography } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import "../styles/product-detail.css";
import React from "react";
import { VerticalCarousel } from "../components/VerticalCarousel";
import { Breadcrumb } from "../components/Breadcrumb";
import NotFound from "../components/Pages/NotFound";
import { GetProductsWithImages, UpdateProductInfo } from "../services/ApiServices/ProductService";
import { GetAllColorsOfProduct } from "../services/ApiServices/ColorService";
import { GetAllSizesOfProduct } from "../services/ApiServices/SizeService";
import { formatPrice } from "../services/formatPrice";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, TextField, Select } from "@mui/material";
import { ProductImageGallery } from "../components/Pages/ProductImageGallery";

type Product = {
    id: string;
    name: string;
    type: string;
    description: string;
    price: number;
    status: string;
    productImages: ProductImage[];
    variantTypes: any;
    quantity: number;
}

type ProductImage = {
    imageUrl: string;
    id: number;
}

type Size = {
    id: string;
    name: string;
}

type SizeQuantity = {
    sizes: { [key: string]: number };
}

type ProductDetailProps = {
    token: string | null
    fetchCartProducts: () => void
    products: any,
    setProducts: (products: any) => void
    setSuccessMessage: (successMessage: string) => void
    setLoading: (loading: boolean) => void
    GetProductSize: (id: any) => Promise<any>
}

function AdminProductDetail({ token, GetProductSize, fetchCartProducts, products, setProducts, setSuccessMessage, setLoading }: ProductDetailProps) {
    const { id } = useParams();
    const [product, setProduct] = useState({} as Product);
    const [quantity, setQuantity] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [variantErrorMessage, setVariantErrorMessage] = useState("");

    const [sizes, setSizes] = useState<Size[]>([]);

    const [openAcc1, setOpenAcc1] = React.useState(false);
    const [openAcc2, setOpenAcc2] = React.useState(false);
    const [openAcc3, setOpenAcc3] = React.useState(false);

    const handleOpenAcc1 = () => setOpenAcc1((cur) => !cur);
    const handleOpenAcc2 = () => setOpenAcc2((cur) => !cur);
    const handleOpenAcc3 = () => setOpenAcc3((cur) => !cur);

    const [activeCarouselImage, setActiveCarouselImage] = useState(<></>);
    const [prevMainImage, setPrevMainImage] = useState(<></>);
    const [mainImage, setMainImage] = useState(<></>);
    const [showImage, setShowImage] = useState(<></>);
    const [carouselImages, setCVariantTypesarouselImages] = useState(<></>);
    const [sizeQuantities, setsizeQuantities] = useState<SizeQuantity[]>([]);

    const [openDialog, setOpenDialog] = useState(false);
    const [formState, setFormState] = useState({
        name: '',
        description: '',
        price: '',
        type: '',
        quantity: '',
        status: '',
        sizeId: '',
        colorId: ''
    });

    const fetchProduct = async () => {
        setLoading(true);
        try {
            const product = await GetProductsWithImages(id);
            setProduct(product);
            const colors = await GetAllColorsOfProduct(product.id);
            const sizes = await GetAllSizesOfProduct(product.id);
            setSizes(sizes);
        } catch (error) {
            setErrorMessage((error as any).response?.data?.message || 'An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            const updatedProduct = {
                ...product,
                ...formState,
                price: parseFloat(formState.price),
                quantity: parseInt(formState.quantity),
                colorSizeQuantities: sizeQuantities,
                // sizeId: formState.sizeId,
                // colorId: formState.colorId,
            };
            await UpdateProductInfo(updatedProduct);
            await fetchProduct();
            setSuccessMessage('Product updated successfully.');
            setTimeout(() => setSuccessMessage(''), 2000);
            setOpenDialog(false);
        } catch (error) {
            setErrorMessage((error as any).response?.data?.message || 'An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchProduct();
    }, []);

    useEffect(() => {
        if (product.productImages?.length > 0) {
            setActiveCarouselImage(
                <img src={product.productImages[0].imageUrl} alt="product image" className="h-full w-full" />
            );
        }
    }, [product]);

    useEffect(() => {
        setMainImage(activeCarouselImage);
        setPrevMainImage(activeCarouselImage);
    }, [activeCarouselImage]);

    useEffect(() => {
        setShowImage(mainImage);
    }, [mainImage]);

    if (!id) {
        return (
            <NotFound />
        )
    }

    if (!product.price) {
        setTimeout(() => setLoading(false), 3000);
        return <div>Product not found</div>;
    }

    const handleOpenDialog = () => {
        setFormState({
            name: product.name,
            description: product.description,
            type: product.type,
            price: product.price.toString(),
            quantity: product.quantity.toString(),
            status: product.status,
            sizeId: '',
            colorId: '',
        });
        setOpenDialog(true);
    };

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormState((prev) => ({ ...prev, [name]: value }));
    };

    const handleColorSizeChange = (index: number, type: string, sizeId: string, value: any) => {
        const updatedSizeQuantities = [...sizeQuantities];
        if (type === "color") {
            updatedSizeQuantities[index] = {
                ...updatedSizeQuantities[index],
            };
        } else if (type === "sizes") {
            updatedSizeQuantities[index] = {
                ...updatedSizeQuantities[index],
                sizes: {
                    ...updatedSizeQuantities[index].sizes,
                    [sizeId]: parseInt(value),
                },
            };
        }
        setsizeQuantities(updatedSizeQuantities);
    };


    return (
        <>
            {setLoading(false)}
            <div className="w-full p-4">
                <div className="flex flex-wrap w-full gap-5 md:flex-nowrap">
                    <div>
                        <ProductImageGallery productImages={product.productImages} />
                    </div>
                    <div className="w-12/12 md:w-5/12">
                        <Card placeholder={""}>
                            <CardBody className="product-detail-body" placeholder={""}>
                                <div className="flex">
                                    <div className="flex items-center gap-3 me-3">
                                        <div className="flex">
                                            <StarIcon fill="black" width={20} height={20} />
                                            <StarIcon fill="black" width={20} height={20} />
                                            <StarIcon fill="black" width={20} height={20} />
                                            <StarIcon fill="black" stroke="black" width={20} height={20} />
                                            <StarIcon fill="black" stroke="black" width={20} height={20} />
                                        </div>
                                        <div>20 Đánh giá</div>
                                    </div>
                                    <Link to={"#"} className="text-orange-500 underline">Viết đánh giá</Link>
                                </div>
                                <div>
                                    <h1 className="text-2xl font-semibold mb-3">{product?.name}</h1>
                                    <div className="text-xl font-semibold text-red-500 mb-3">{formatPrice(product.price)}</div>
                                </div>

                                <div className={`${variantErrorMessage ? "bg-red-50 p-3" : ""} rounded`}>
                                    <div className="mb-5">
                                        <Typography placeholder={""}>Kích cỡ</Typography>
                                        {sizes.length != 0 &&
                                            (<List className="variant-type-row flex-row flex-wrap" placeholder={""}>
                                                {sizes.map((size: any, index: number) => (
                                                    <ListItem className={`variant-btn size-btn text-black min-w-0 w-32 p-0`} placeholder={""}
                                                        onMouseEnter={() => {
                                                            /*if(variant.imageUrl)
                                                            setShowImage(
                                                                <img src={variant.imageUrl} alt="product image" className="h-full w-full" />
                                                            )*/
                                                        }}
                                                        onMouseLeave={() => {
                                                            //setShowImage(mainImage)
                                                        }}
                                                        onClick={(e) => {
                                                            let button = e.currentTarget
                                                            let radio = button.getElementsByTagName("input")[0]
                                                            let buttons = document.getElementsByClassName("size-btn")
                                                            for (let i = 0; i < buttons.length; i++) {
                                                                buttons[i].classList.remove("variant-active");
                                                            }
                                                            if (!button.classList.contains("variant-active")) {
                                                                //setPrevMainImage(mainImage)
                                                                /*if(variant.imageUrl)
                                                                setMainImage(
                                                                    <img src={variant.imageUrl} alt="product image" className="h-full w-full" />
                                                                )*/
                                                            }
                                                            else {
                                                                //setMainImage(activeCarouselImage)
                                                            }
                                                            button.classList.toggle("variant-active");
                                                            radio.click();
                                                        }}>
                                                        <label
                                                            htmlFor={`horizontal-list-${index}`}
                                                            className="flex w-full cursor-pointer items-center px-3 py-2"
                                                        >
                                                            <ListItemPrefix className="mr-3" placeholder={""}>
                                                                <Radio
                                                                    name={"size"}
                                                                    id={`${"size"}-${index}`}
                                                                    value={size.id}
                                                                    ripple={false}
                                                                    className="variant-radio hover:before:opacity-0 hidden"
                                                                    containerProps={{
                                                                        className: "p-0",
                                                                    }}
                                                                    crossOrigin={""}
                                                                    iconProps={{
                                                                        className: "hidden"
                                                                    }}
                                                                    onChange={(e) => {
                                                                        //const radio = e.currentTarget
                                                                        //console.log(radio.value)
                                                                    }}
                                                                    onLoad={(e) => {
                                                                        //console.log(type.description)
                                                                        /*if(type.description=="Default")
                                                                            e.currentTarget.checked = true;*/
                                                                    }}
                                                                />
                                                            </ListItemPrefix>
                                                            <Typography
                                                                color="blue-gray"
                                                                className="font-medium text-blue-gray-400"
                                                                placeholder={""}
                                                            >

                                                                {size.name}
                                                            </Typography>
                                                        </label>
                                                    </ListItem>
                                                ))}
                                            </List>
                                            )}
                                    </div>
                                    <div className="text-red-500">{variantErrorMessage}</div>
                                </div>
                                <div className="mb-5">
                                    <div className="product-size-select ">
                                        <div className="flex items-center gap-3">
                                            <Typography className="me-1 font-bold" placeholder={""}>Số lượng:</Typography>
                                            <p className="">{product.quantity} sản phẩm có sẵn</p>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                {/* <Button placeholder={""}
                                    variant="filled"
                                    className="flex justify-center gap-3 w-full mb-5 rounded-full"
                                    style={{ backgroundColor: 'orange', color: 'white' }}
                                    onClick={handleOpenDialog}
                                >
                                    <ShoppingCartIcon fill="none" stroke="white" width={20} height={20} />
                                    <span className="text-white">Cập nhật</span>
                                </Button> */}
                                <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                                    <DialogTitle>Cập nhật Sản phẩm</DialogTitle>
                                    <DialogContent>
                                        <TextField
                                            margin="dense"
                                            label="Tên"
                                            type="text"
                                            fullWidth
                                            name="name"
                                            value={formState.name}
                                            onChange={handleChange}
                                        />
                                        <TextField
                                            margin="dense"
                                            label="Mô tả"
                                            type="text"
                                            fullWidth
                                            name="description"
                                            value={formState.description}
                                            onChange={handleChange}
                                        />
                                        <FormControl fullWidth margin="dense">
                                            <InputLabel shrink>Loại sản phẩm</InputLabel>
                                            <Select
                                                value={formState.type}
                                                onChange={handleChange}
                                                name="type"
                                                displayEmpty
                                            >
                                                <MenuItem value="" disabled>
                                                    <em>Chọn loại sản phẩm</em>
                                                </MenuItem>
                                                <MenuItem value="Quần">Quần</MenuItem>
                                                <MenuItem value="Áo">Áo</MenuItem>
                                                <MenuItem value="Giày">Giày</MenuItem>
                                                <MenuItem value="Áo khoác ngoài">Áo khoác ngoài</MenuItem>
                                                <MenuItem value="Phụ kiện">Phụ kiện</MenuItem>
                                                <MenuItem value="Sale">Sale</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            margin="dense"
                                            label="Giá"
                                            type="number"
                                            fullWidth
                                            name="price"
                                            value={formState.price}
                                            onChange={handleChange}
                                        />
                                        <TextField
                                            margin="dense"
                                            label="Số lượng"
                                            type="number"
                                            fullWidth
                                            name="quantity"
                                            value={formState.quantity}
                                            onChange={handleChange}
                                        />
                                        <TextField
                                            select
                                            margin="dense"
                                            label="Trạng thái"
                                            fullWidth
                                            name="status"
                                            value={"Active"}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Inactive">Inactive</MenuItem>
                                        </TextField>
                                        {sizeQuantities.map((sizeQuantity, index) => (
                                            <div key={index}>
                                                {sizes.map((size) => (
                                                    <TextField
                                                        key={`${index}-${size.id}`}
                                                        label={`Số lượng Size ${size.name}`}
                                                        type="number"
                                                        fullWidth
                                                        value={sizeQuantity.sizes[size.id] || 0}
                                                        onChange={(e) => handleColorSizeChange(index, "sizes", size.id, e.target.value)}
                                                    />
                                                ))}
                                            </div>
                                        ))}

                                    </DialogContent>
                                    <DialogActions>
                                        <Button placeholder={""} onClick={() => setOpenDialog(false)} color="light-blue">
                                            Hủy bỏ
                                        </Button>
                                        <Button placeholder={""} onClick={handleUpdate} color="light-green">
                                            Cập nhật
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminProductDetail;